export function extractOrdersFromFamilies(data: any) {
    if (!data?.families) return data;
    const { families, ...rest } = data;

    return {
        ...rest,
        orders: families
            .filter((fam: any): fam is { rootOrder: any } => !!fam && !!(fam as any).rootOrder)
            .map((fam: any) => fam.rootOrder)
    };
}